import { urls } from "../../urls";

export const isAppShellPath = (pathname: string): boolean =>
  pathname !== urls.portal.root && !pathname.startsWith(`${urls.portal.root}/`);
